import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { DateType } from "../../../../static/types/commonTypes/dateType";
import { IndividualPersonType } from "../../../../static/types/commonTypes/individualType";
import DateComponent from "../../../commonComponents/DateComponent";
import IndividualPerson from "../../../commonComponents/IndividualPerson";

const WillDetails = () => {

    const {

        dateOfWill, setDateOfWill,
        dateOfWillValidity, setDateOfWillValidity,
        dateOfWillChecked, setDateOfWillChecked,

        dateOfFiling, setDateOfFiling,
        dateOfFilingValidity, setDateOfFilingValidity,
        dateOfFilingChecked, setDateOfFilingChecked,

        dateOfReceipt, setDateOfReceipt,
        dateOfReceiptValidity, setDateOfReceiptValidity,
        dateOfReceiptChecked, setDateOfReceiptChecked,

        typeHeirsData, setTypeHeirsData,

        individual, setIndividual,
        individualValidity, setIndividualValidity,
        individualChecked, setIndividualChecked,

    } = useAppContext() as AppContextType

    const updateDateOfWill = (data: Partial<DateType>) => setDateOfWill({ ...dateOfWill, ...data })
    const updateDateOfFiling = (partialData: Partial<DateType>) => setDateOfFiling({...dateOfFiling, ...partialData})
    const updateDateOfReceipt = (partialData: Partial<DateType>) => setDateOfReceipt({...dateOfReceipt, ...partialData})
    const updateIndividual = (partialData: Partial<IndividualPersonType>) => setIndividual({...individual,...partialData})

    return (
        <div className="container py-2">
            <div className="mb-3">
                <DateComponent
                id="dateOfWill"
                changeDate={updateDateOfWill}
                checked={dateOfWillChecked}
                date={dateOfWill}
                draftFieldName = "dateOfWill"
                dateLabel="Date du testament"
                required={true}
                onValidationChange={(isValid: boolean) => setDateOfWillValidity(isValid)}
                />
            </div>
            <div className="mb-3"
                style={{marginTop: '-3rem'}}>
                <DateComponent
                id="dateOfFilling"
                draftFieldName = "dateOfFiling"
                changeDate={updateDateOfFiling}
                checked={dateOfFilingChecked}
                date={dateOfFiling}
                dateLabel="Date du dépôt"
                required={true}
                onValidationChange={(isValid: boolean) => setDateOfFilingValidity(isValid)}
                />
            </div>
            <div className="mb-3"
                style={{marginTop: '-3rem'}}>
                <DateComponent
                id="dateOfReceipt"
                changeDate={updateDateOfReceipt}
                checked={dateOfReceiptChecked}
                date={dateOfReceipt}
                draftFieldName = "dateOfReceipt"
                dateLabel="Date C.A"
                required={true}
                onValidationChange={(isValid: boolean) => setDateOfReceiptValidity(isValid)}
                />
            </div>
            <div className="row"
                style={{marginTop: '-1.7rem', marginLeft: '0.8rem'}}>
                <label htmlFor="personne" className="col-4 col-form-label fw-bold mb-1" style={{marginRight: '-100px'}}>
                    Légataires
                </label>
                <div className="col-6" style={{marginLeft: '90px'}}>
                    <select
                        className="form-select w-auto"
                        id="person"
                        onChange={(e) => {
                        setTypeHeirsData(Number(e.target.value));
                        }}
                        value={typeHeirsData}
                >
                    <option value={0}>Un légataire</option>
                    <option value={1}>Deux légataires ou plus</option>
                </select>
                </div>
            </div>
            <div className="mt-3">
                <h6 className="text-bold ml-sm-4"
                    style={{backgroundColor: "#4DB0BB", padding: "0.6rem", color: "white"}}>
                        Notaire officiant
                </h6>
                <IndividualPerson
                    individual= {individual}
                    checked= {individualChecked}
                    changeIndividual= {updateIndividual}
                    onValidationChange= {(isValid: boolean) => setIndividualValidity (isValid)}
                    draftFieldName = "individual"
                />
            </div>
        </div>
)}

export default WillDetails;